import type { MutableRefObject, RefObject } from "react";

import type { TimelineViewTransform } from "../ViewTransform/transform";
import { applyWheelToViewTransform } from "../ViewTransform/transform";

export function bindLockedFollowWheelZoom(
  ref: RefObject<
    | ((
        factor: number,
        pointerX: number,
        pointerY: number,
        stageW: number,
        stageH: number,
      ) => void)
    | null
  >,
  cameraLockEnabled: boolean,
  followZoomRef: MutableRefObject<number>,
  viewRef: MutableRefObject<TimelineViewTransform>,
  resolveViewTransform: () => TimelineViewTransform,
  setViewTransform: (view: TimelineViewTransform) => void,
  onManualZoom: () => void,
): void {
  ref.current = (factor, pointerX, pointerY, stageW, stageH): void => {
    if (!cameraLockEnabled) {
      return;
    }
    onManualZoom();
    followZoomRef.current = applyWheelToViewTransform(
      viewRef.current,
      stageW,
      stageH,
      pointerX,
      pointerY,
      factor,
    ).zoom;
    const view = resolveViewTransform();
    setViewTransform(view);
  };
}
